import React, { Fragment, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import CartDrawerHeader from '../CartDrawerHeader/CartDrawerHeader';
// import CartDrawerSwymCta from '../CartDrawerSwymCta/CartDrawerSwymCta';
import LineItemList from '../LineItemList/LineItemList';
import DonateADollar from '../DonateADollar/DonateADollar';
import CartDrawerFooter from '../CartDrawerFooter/CartDrawerFooter';

import { getCartItems } from '../../Utils/CartUtils';

import { StyledDiv, StyledNoProducts, StyledSticky, StyleButtonWrapper, StyledButton, StyledHelp } from './CartDrawerStyles';

var _ref = React.createElement(
  'span',
  null,
  'Need Help With Your Order? Text'
);

var _ref2 = React.createElement(
  'a',
  { href: 'sms:+1-413-992-6436' },
  '1-413-992-6436'
);

var _ref3 = React.createElement(
  StyledNoProducts,
  null,
  'Oops! Nothing here yet, but let\u2019s change that'
);

var CartDrawer = function CartDrawer(props) {
  var cartDrawerRef = useRef(null);
  var lineItemCount = useRef(props.checkout.lineItems.edges.length);

  useEffect(function () {
    var handleOutsideCartDrawerClick = function handleOutsideCartDrawerClick(e) {
      var CartDrawerDiv = document.querySelector('.CartDrawer');
      var ProductAddOnModal = document.querySelector('.ProductAddOnModal');
      var PageContainer = document.querySelector('#PageContainer');
      var fourSixtyModal = document.querySelector('.fs-detail-container');
      // if ProductAddOnModal is active and clicked, don't close cart. (break out of function)
      if (ProductAddOnModal && (e.target === ProductAddOnModal || ProductAddOnModal.contains(e.target))) {
        return false;

        // if PageContainer click outside of CarteDrawerDiv, close cart drawer
      } else if (props.isCartOpen && PageContainer.contains(e.target) && e.target !== CartDrawerDiv && !CartDrawerDiv.contains(e.target)) {
        props.handleCartClose();

        // if fourSixty modal click, close cart drawer
      } else if (props.isCartOpen && fourSixtyModal && fourSixtyModal.contains(e.target)) {
        props.handleCartClose();
      }
    };
    document.addEventListener('click', handleOutsideCartDrawerClick);
    return function () {
      document.removeEventListener('click', handleOutsideCartDrawerClick);
    };
  });

  useEffect(function () {
    // if item added to cart, scroll to top of cart
    if (lineItemCount.current < props.checkout.lineItems.edges.length && document.querySelector('.CartDrawer')) {
      document.querySelector('.CartDrawer').scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
    lineItemCount.current = props.checkout.lineItems.edges.length;
  }, [props.checkout.lineItems.edges.length]);

  useEffect(function () {
    // add effect to toggle visibility for cart drawer when opened/closed
    if (props.isCartOpen === true && cartDrawerRef.current) {
      cartDrawerRef.current.style.visibility = 'visible';
      cartDrawerRef.current.focus();
    } else {
      setTimeout(function () {
        cartDrawerRef.current.style.visibility = 'hidden';
      }, 400);
    }
  }, [props.isCartOpen]);

  var handleLiveChatClick = function handleLiveChatClick() {
    props.handleCartClose();
    zE.activate();
  };

  var openCheckout = function openCheckout(webUrl) {
    // Strip the domain to use same domain as present
    var relativeUrl = webUrl.replace('https://dormifyplus.myshopify.com', '');
    window.location.href = relativeUrl;
  };

  var lineItems = props.checkout.lineItems.edges;

  var checkoutCustomAttributes = props.checkout.customAttributes;

  var isDonateProductInCart = false;
  if (props.donateADollarPromo && props.donateADollarProduct) {
    isDonateProductInCart = lineItems.some(function (item) {
      return item.node.title === props.donateADollarProduct.title;
    });
  }

  return React.createElement(
    StyledDiv,
    {
      className: 'CartDrawer',
      active: props.isCartOpen,
      ref: cartDrawerRef,
      tabIndex: '-1'
    },
    React.createElement(CartDrawerHeader, {
      checkout: props.checkout,
      items: lineItems,
      cartQuantity: props.cartQuantity,
      handleCartClose: props.handleCartClose,
      addCheckoutNote: props.addCheckoutNote,
      addDiscountCode: props.addDiscountCode,
      removeDiscountCode: props.removeDiscountCode,
      noVendorItems: getCartItems(lineItems, 'VENDOR').length === 0,
      addPlusReleaseDate: props.addPlusReleaseDate,
      checkoutNote: props.checkout.note,
      checkoutDiscountCodes: props.checkout.discountApplications,
      checkoutCustomAttributes: checkoutCustomAttributes,
      autoDiscountPromo: props.autoDiscountPromo,
      autoDiscountCode: props.autoDiscountCode,
      autoDiscountCodeEndDate: props.autoDiscountCodeEndDate,
      formSubmitted: props.formSubmitted,
      formDiscountCode: props.formDiscountCode,
      discountThresholdAmount: props.discountThresholdAmount
    }),
    React.createElement(
      StyledSticky,
      null,
      React.createElement(
        StyleButtonWrapper,
        { isCartOpen: props.isCartOpen },
        React.createElement(
          StyledButton,
          {
            className: 'btn btn--full gradient-shimmer btn--proceed-to-checkout',
            disabled: props.cartQuantity === 0,
            onClick: function onClick() {
              return openCheckout(props.checkout.webUrl);
            }
          },
          'Proceed To Checkout'
        )
      )
    ),
    React.createElement(
      StyledHelp,
      null,
      _ref,
      _ref2,
      '|',
      React.createElement(
        'button',
        { onClick: handleLiveChatClick },
        'Live Chat'
      )
    ),
    lineItems.length > 0 ? React.createElement(
      Fragment,
      null,
      React.createElement(LineItemList, {
        title: 'Delivered Immediately' // Virtual Gift Card
        , subTitle: 'NOT ELIGIBLE FOR BUY NOW, SHIP LATER',
        items: getCartItems(lineItems, 'VIRTUAL'),
        removeLineItemInCart: props.removeLineItemInCart,
        updateLineItemInCart: props.updateLineItemInCart
      }),
      React.createElement(LineItemList, {
        title: 'Ships In ' + props.shippingTimes.photograShipping + ' Business Days' // Changed from 24-48 days because COVID
        , subTitle: 'NOT ELIGIBLE FOR BUY NOW, SHIP LATER',
        items: getCartItems(lineItems, 'PHOTOGRA'),
        removeLineItemInCart: props.removeLineItemInCart,
        updateLineItemInCart: props.updateLineItemInCart
      }),
      React.createElement(LineItemList, {
        title: 'Ships In ' + props.shippingTimes.cheyenneShipping + ' Business Days' // Changed from 24-48 days because COVID
        , subTitle: 'NOT ELIGIBLE FOR BUY NOW, SHIP LATER',
        items: getCartItems(lineItems, 'CHEYENNE'),
        removeLineItemInCart: props.removeLineItemInCart,
        updateLineItemInCart: props.updateLineItemInCart
      }),
      React.createElement(LineItemList, {
        title: 'Ships In ' + props.shippingTimes.skylineFurnitureShipping + ' Weeks' // Changed from 24-48 days because COVID
        , subTitle: 'NOT ELIGIBLE FOR BUY NOW, SHIP LATER',
        items: getCartItems(lineItems, 'SKYLINE_FURNITURE'),
        removeLineItemInCart: props.removeLineItemInCart,
        updateLineItemInCart: props.updateLineItemInCart
      }),
      React.createElement(LineItemList, {
        title: 'Ships In ' + props.shippingTimes.defaultShipping + ' Business Days' // Changed from 24-48 days because COVID
        , subTitle: 'ELIGIBLE FOR BUY NOW, SHIP LATER',
        items: getCartItems(lineItems, 'WAREHOUSE'),
        removeLineItemInCart: props.removeLineItemInCart,
        updateLineItemInCart: props.updateLineItemInCart
      }),
      React.createElement(LineItemList, {
        title: 'Ships In ' + props.shippingTimes.customShipping + ' Business Days' // Changed from 24-48 days because COVID
        , subTitle: 'NOT ELIGIBLE FOR BUY NOW, SHIP LATER',
        items: getCartItems(lineItems, 'CUSTOM'),
        removeLineItemInCart: props.removeLineItemInCart,
        updateLineItemInCart: props.updateLineItemInCart
      }),
      React.createElement(LineItemList, {
        title: 'Ships In ' + props.shippingTimes.nonWarehouseShipping + ' Business Days' // Changed from 5-8 days because COVID
        , subTitle: 'NOT ELIGIBLE FOR BUY NOW, SHIP LATER',
        items: getCartItems(lineItems, 'VENDOR'),
        removeLineItemInCart: props.removeLineItemInCart,
        updateLineItemInCart: props.updateLineItemInCart
      })
    ) : _ref3,
    props.donateADollarPromo === true && !isDonateProductInCart && React.createElement(DonateADollar, {
      donateADollarProduct: props.donateADollarProduct,
      addVariantToCart: props.addVariantToCart,
      checkout: props.checkout,
      donationBoxCopy: props.donationBoxCopy
    }),
    React.createElement(CartDrawerFooter, {
      addVariantToCart: props.addVariantToCart,
      checkout: props.checkout
    })
  );
};

CartDrawer.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  updateCartQuantity: PropTypes.func.isRequired,
  removeLineItemInCart: PropTypes.func.isRequired,
  updateLineItemInCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  isCartOpen: PropTypes.bool.isRequired,
  cartQuantity: PropTypes.number,
  handleCartClose: PropTypes.func,
  donateADollarPromo: PropTypes.bool,
  donateADollarProduct: PropTypes.object,
  addCheckoutNote: PropTypes.func,
  addDiscountCode: PropTypes.func,
  formSubmitted: PropTypes.bool,
  formDiscountCode: PropTypes.string,
  removeDiscountCode: PropTypes.func,
  addPlusReleaseDate: PropTypes.func,
  autoDiscountPromo: PropTypes.bool,
  autoDiscountCode: PropTypes.string,
  autoDiscountCodeEndDate: PropTypes.string,
  discountThresholdAmount: PropTypes.string,
  donationBoxCopy: PropTypes.string,
  shippingTimes: PropTypes.object
};

export default CartDrawer;